module.exports = __webpack_public_path__ + "static/media/salesmanagement.4fe12324.mp4";